export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';
export const LOGO_URL = "/logo-nav.png";
export const LOGO_URL_WHITE = "/logo-nav-white.png";
export const BG_IMAGE = "/bg-pattern.jpg";
export const CALENDLY_URL = "https://calendly.com/yvar-yrvante/30min";
